import React from "react";
import logo2 from '../../images/publicis-edge-logo-2.png';
import title from '../../images/cultural_fluency_logo.jpg';
import { withAuthenticator } from "@aws-amplify/ui-react";

function Header({ signOut }) {
    return (
        <div className="pre-header">
            <div className="logo-header">
                <a href="mailto:gettheedge@publicisgroupe.com?subject=Cultural%20Fluency%20Feedback">
                    <img src={logo2} alt="logo" />
                </a>
                <div className="title-header">
                    <img src={title} alt="title" />
                </div>
            </div>
            <div className="signout font-oswald-bold text-lg uppercase cursor-pointer flex items-center" onClick={signOut}>
                Sign Out
            </div>
        </div>
    );
}

export default withAuthenticator(Header);